import { getScreenName } from '../../Utils/helper';

import { fireEvent } from '../../Utils/fireEvent';

const getFreeBieSkuIds = (FreebieProducts) => {
  let array = [];
  FreebieProducts.forEach((element) => {
    array.push(element?._id);
  });
  array.join(',');
  return array;
};
export const fireServedSectionInCartOverlay = (
  FreebieProducts,
  Offers,
  cartminAmountError,
) => {
  fireEvent({
    category: 'served_section_in_cart_overlay',
    screen_name: getScreenName(),
    sku_id: getFreeBieSkuIds(FreebieProducts),
    term_id: Offers.term_id,
    offer_name: Offers.name,
    item_state: cartminAmountError ? 'locked' : 'unlocked',
    display_type: 'overlay',
    deeplink: Offers.deeplink,
  });
};
export const fireExpandDropdown = (Offers, cartminAmountError) => {
  fireEvent({
    category: 'clicked_expand_dropdown',
    screen_name: getScreenName(),
    term_id: Offers.term_id,
    offer_name: Offers.name,
    item_state: cartminAmountError ? 'locked' : 'unlocked',
    display_type: 'overlay',
    deeplink: Offers.deeplink,
  });
};
export const fireCollapseDropdown = (Offers, cartminAmountError) => {
  fireEvent({
    category: 'clicked_discard_dropdown',
    screen_name: getScreenName(),
    term_id: Offers.term_id,
    offer_name: Offers.name,
    item_state: cartminAmountError ? 'locked' : 'unlocked',
    display_type: 'overlay',
    deeplink: Offers.deeplink,
  });
};
export const fireChangeProductHandler = (user_offers) => {
  fireEvent({
    category: 'clicked_cta',
    screen_name: getScreenName(),
    display_type: 'overlay',
    term_id: user_offers?.offers?.[0]?.term_id,
    offer_name: user_offers?.offers?.[0]?.name,
    parent: 'freebie_offer',
    deeplink: user_offers?.offers?.[0]?.deeplink,
    deeplink_value: user_offers?.offers?.[0]?.deeplink,
  });
};
export const fireAddToCart = (Offers, index, data) => {
  fireEvent({
    category: 'clicked_add_to_cart',
    screen_name: getScreenName(),
    sku_id: data?._id,
    parent: 'offer_listing',
    term_id: Offers.term_id,
    offer_name: Offers.name,
    item_state: 'unlocked',
    display_type: 'overlay',
    deeplink: Offers.deeplink,
    position: index,
  });
};
export const fireViewedPopupEvent = (popupData) => {
  fireEvent({
    category: 'viewed_popup',
    screen_name: getScreenName(),
    parent: 'offer_popup',
    term_id: popupData.term_id,
    offer_name: popupData.name,
    deeplink: popupData.deeplink,
    deeplink_value: popupData.deeplink_value,
  });
};
export const fireDiscardPopupEvent = (popupData) => {
  fireEvent({
    category: 'discard_popup',
    screen_name: getScreenName(),
    parent: 'offer_popup',
    term_id: popupData.term_id,
    offer_name: popupData.name,
    deeplink: popupData.deeplink,
    deeplink_value: popupData.deeplink_value,
  });
};
export const fireServedSectionEvent = (data) => {
  fireEvent({
    category: 'served_section_in_general_screen',
    screen_name: getScreenName(),
    section_name: 'timer_with_strip',
    section_id: data?._id,
    shape: data?.itemType,
    deeplink: data?.deeplink,
    deeplink_value: data?.deeplinkValue,
  });
};
export const fireClickedCardEvent = (data) => {
  fireEvent({
    category: 'clicked_card_in_myloshop',
    screen_name: getScreenName(),
    section_name: 'timer_with_cta',
    section_id: data?._id,
    shape: data?.itemType,
    deeplink: data?.deeplink,
    deeplink_value: data?.deeplinkValue,
  });
};
export const fireServedSectionInMyloshop = (data) => {
  fireEvent({
    category: 'served_section_in_myloshop',
    screen_name: getScreenName(),
    section_name: 'timer_with_cta',
    section_id: data?._id,
    shape: data?.itemType,
    deeplink: data?.deeplink,
    deeplink_value: data?.deeplinkValue,
  });
};
export const fireServedSectionInPdp = (
  data,
  // pricingParam,
  // conversionParam,
  // productData,
) => {
  fireEvent({
    category: 'served_section_in_pdp',
    screen_name: getScreenName(),
    section_name: 'timer',
    section_id: data?._id,
    shape: data?.itemType,
    deeplink: data?.deeplink,
    deeplink_value: data?.deeplinkValue,
    // pricing_param: pricingParam,
    // conversion_param: conversionParam,
    // product_id: productData?.id || "NA",
    // product_name: productData?.NAME,
  });
};
